import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameSettingsComponent } from '@app/_v2/games/shared/game-settings/game-settings.component';
import { GameStatisticsComponent } from '@app/_v2/games/shared/game-statistics/game-statistics.component';
import { RouterModule } from '@angular/router';
import { ChipSelectorV2Component } from '@app/_v2/games/shared/chip-selector-v2/chip-selector.component';
import { SharedModule } from '@app/shared';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AwardModalComponent } from './award-modal/award-modal.component';
import { AwardSummaryModalComponent } from './award-summary-modal/award-summary-modal.component';
import { FreeSpinsProgressComponent } from '@app/_v2/games/shared/free-spins-progress/free-spins-progress.component';
import { FormsModule } from '@angular/forms';
import { GameDisabledComponent } from '@app/_v2/games/shared/game-disabled.component';
import { FloorPipe } from '@app/core/pipes/math/floor.pipe';
import { LeaderboardBetsWrapperComponent } from '@app/_v2/games/shared/leaderboard-bets-wrapper/leaderboard-bets-wrapper.component';
import { LeaderboardComponent } from '@app/_v2/games/shared/leaderboard-bets-wrapper/leaderboard/leaderboard.component';
import { LatestBetsComponent } from '@app/_v2/games/shared/leaderboard-bets-wrapper/latest-bets/latest-bets.component';
import { ChipSelectorV3Component } from './chip-selector-v3/chip-selector-v3.component';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, NgbTooltipModule, FormsModule],
  exports: [
    RouterModule,
    GameSettingsComponent,
    GameStatisticsComponent,
    ChipSelectorV2Component,
    AwardModalComponent,
    AwardSummaryModalComponent,
    FreeSpinsProgressComponent,
    GameDisabledComponent,
    LeaderboardBetsWrapperComponent,
    LeaderboardComponent,
    LatestBetsComponent,
    ChipSelectorV3Component,
  ],
  declarations: [
    GameSettingsComponent,
    GameStatisticsComponent,
    ChipSelectorV2Component,
    AwardModalComponent,
    AwardSummaryModalComponent,
    FreeSpinsProgressComponent,
    GameDisabledComponent,
    FloorPipe,
    LeaderboardBetsWrapperComponent,
    LeaderboardComponent,
    LatestBetsComponent,
    ChipSelectorV3Component,
  ],
  providers: [],
  entryComponents: [
    //
  ],
})
export class SharedGamesV2Module {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/shared/shared-games.module.ts